import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MaterialComponent from "./MaterialComponent";
import { Link } from "react-router-dom";
// import Modal from "react-modal";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row } from "reactstrap";
import Spinner from "../../sample/spinner";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
import Chip from "@material-ui/core/Chip";
import Latex from "./Latex";
class McqAssesment extends Component {
  constructor(props) {
    super(props);
    const mcqlist = [];
    const TotalMcq = [];
    const solved = [];
    const iscorrect = [];

    this.state = {
      contentType: props.contentType,
      contentId: props.contentId,
      mcqlist,
      TotalMcq,
      solved,
      iscorrect,
      selectedOption: "",
      contenttype: "",
      materialid: "",
      materiapath: "",
      filepath: "",
      fulename: "",
      contentid: "",
      materialtype: "",
      modalIsOpen: false,
      secondModalIsOpen: false,
      selectedoption: "",
      loading: false,
      showComponent: false,
    };

    this.onSiteChanged = this.onSiteChanged.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    // this.openSecondModal = this.openSecondModal.bind(this);
    this.closeSecondModal = this.closeSecondModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false,filename:"",filepath:"" });
  }

  // openSecondModal(file) {
  //   console.log("aaa")
  //   this.setState({
  //     secondModalIsOpen: true,
  //     filepath: file,
  //     filename: file.split(".").pop(),
  //   });
  // }

  closeSecondModal() {
    this.setState({ secondModalIsOpen: false ,filename:"",filepath:""});
  }

  onSiteChanged(event) {
    // console.log(event.target.value);
    this.setState({
      selectedOption: event.target.value,
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.contentType !== this.props.contentType ||
      prevProps.contentId !== this.props.contentId
    ) {
      if (this.props.contentType === "Topiclevel") {
        this.getTopicMcq();
      } else {
        this.getUnitMcq();
      }
    }
  }
  componentDidMount() {
    if (this.props.contentType === "Topiclevel") {
      this.getTopicMcq();
    } else {
      this.getUnitMcq();
    }
  }
  async getTopicMcq() {
    this.setState({ showComponent: true });
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("topicId", this.props.contentId);
    axios
      .post("LearnerAssignment/getTopicMcq", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            mcqlist: res.data.mcqlist,
            TotalMcq: res.data.TotalMcq,
            solved: res.data.solved,
            showComponent: false,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  async getUnitMcq() {
    this.setState({ showComponent: true });
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("topicId", this.props.contentId);
    axios
      .post("LearnerAssignment/getUnitMcq", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            mcqlist: res.data.mcqlist,
            TotalMcq: res.data.TotalMcq,
            solved: res.data.solved,
            showComponent: false,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {
        toast.error("Please try again!!", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }

  sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  handleSubmit(e, questionid, assignmentOfferingid) {
    e.preventDefault();
    this.saveoption(questionid, assignmentOfferingid);
  }

  async saveoption(questionid, assignmentOfferingid) {
    this.setState({ loading: true });
      var formData = new FormData();
      formData.append("opt", this.state.selectedoption);
      formData.append("assoff", assignmentOfferingid);
      formData.append("cofflearn", localStorage.getItem("state"));
      formData.append("topicId", this.props.contentId);
      formData.append("questionid", questionid);
      axios
        .post("LearnerAssignment/saveMCQ", formData)
        .then((res) => {
          if (res.data.status === "200" || res.data.status === "100") {      
            if(res.data.msg){
              toast.success(res.data.msg);
              this.setState({ loading: false, mcqlist: res.data.mcqlist  , selectedoption :""});
          }         
            if(res.data.errormsg ){
              toast.error(res.data.errormsg);
            
              this.setState({ loading: false , selectedoption:"" });
            }
            
          } else {
            toast.error(res.data.errormsg);
          }
        });
    }
 

  render() {
    const customStyles = {
      content: {
        top: "20%",
        left: "20%",
        right: "20%",
        bottom: "20%",
      },
    };

    return (
      <div >
        {this.state.showComponent === true ? (
          <>
            <Spinner />
          </>
        ) : (
          ""
        )}
        <div class="row">
          <div className="col-lg-6">
            <Chip
              label="MCQ"
              variant="outlined"
              className="ft-size"
              color="primary"
            />
          </div>
          <div className="col-lg-6 text-right">
            <Chip
              label={
                "Completed :  " +
                this.state.solved +
                " / " +
                this.state.TotalMcq
              }
              color="primary"
              className="ft-size"
            />
          </div>
        </div>
        <br />
        <div id="style-6" class="scrollmcq">
        {this.state.mcqlist.map((item, indexitem) => (
          <>
            <div class="card p-3 mb-2">
              <div class="row " key={item.mcqquestion}>
                <div class=" col-md-9 col-lg-9 ">
                  {indexitem + 1}) &nbsp;
                  <label className="pb-3" for={item.mcqquestion}>
                    <Latex>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: item.mcqquestion,
                        }}
                      />
                    </Latex>
                  </label>
                  {item.mcqquestionfile ? (
                    <>
                      <Link onClick={(e) =>
                                      this.setState({
                                        secondModalIsOpen: true,
                                        filepath: item?.mcqquestionfile,
                                        filename: item?.mcqquestionfile?.split(".").pop(),
                                      })}>
                        {"  "}Click here to Open Question File{"  "}
                        <FontAwesomeIcon icon={faFileAlt} />{" "}
                      </Link>
                    </>
                  ) : (
                    " "
                  )}
                  <br />
                </div>

                <div class=" col-md-3 col-lg-3 text-right">
                  <Chip
                    label={"weightage :" + item.mcqweightage}
                    className="ft-size"
                  />
                </div>
              </div>
              {item.isattempted === true ? (
                <>
                  {item.mcqoption.map((itemname, index) => (
                    <div key={itemname.id}>
                      <ul style={{ margin: "0rem" }}>
                        <li key={itemname.id}>
                          <Row className="pl-2">
                            <div className="col-2 col-md-2 col-lg-2">
                            <div className="d-flex">
                            <span className="opt">{index + 1}</span>
                              {item.mcqSavoptionid === itemname.id ? (
                                <>
                                  {/* {item.mcqSavoptionid} = {itemname.id } */}
                                  <input
                                    type="radio"
                                    name={item.mcqquestionid}
                                    ngModel={item.mcqquestionid}
                                    // name="selectedoption"
                                    id={itemname.id}
                                    checked={item.mcqquestionid}
                                    //  defaultChecked={itemname.id}
                                    value={itemname.id}
                                    onChange={(e) =>
                                      this.setState({
                                        selectedoption: e.target.value,
                                      })
                                    }
                                    className="adjust-widh"
                                  />
                                </>
                              ) : (
                                <>
                                  <input
                                    type="radio"
                                    name={item.mcqquestionid}
                                    ngModel={item.mcqquestionid}
                                    // name="selectedoption"
                                    id={itemname.id}
                                    //checked={item.mcqquestionid}
                                    //  defaultChecked={itemname.id}
                                    value={itemname.id}
                                    onChange={(e) =>
                                      this.setState({
                                        selectedoption: e.target.value,
                                      })
                                    }
                                    className="adjust-widh"
                                  />
                                </>
                              )}
                            </div></div>
                            <div className="col-10  col-md-10 col-lg-10 radio-adj1 text-left">
                              <label for={itemname.id}>
                                <Latex>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: itemname.option_value,
                                    }}
                                  />
                                </Latex>
                              </label>{" "}
                              {itemname.mcqfilr !== null &&
                              itemname.option_value !== null ? (
                                <>
                                  <Link
                                    onClick={(e) =>
                                      this.setState({
                                        secondModalIsOpen: true,
                                      })
                                    }
                                  >
                                    {"  "}Click here to Open Option  File{"  "}
                                    <FontAwesomeIcon icon={faFileAlt} />{" "}
                                  </Link>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </Row>
                          <div></div>
                        </li>
                      </ul>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {item.mcqoption.map((itemname, index) => (
                    <div key={itemname.id}>
                      <ul style={{ margin: "0rem" }}>
                        <li key={itemname.id}>
                          <Row className="pl-2">
                            <div className="col-2 col-md-2 col-lg-2">
                            <div className="d-flex">
                            <span className="opt">{index + 1}</span>
                              <input
                                // type="radio"
                                // name="selectedoption"
                                // id={itemname.id}
                                // value={itemname.id}
                                // onChange={(e) =>
                                //   this.setState({ selectedoption: e.target.value })
                                // }

                                type="radio"
                                name={item.mcqquestionid}
                                ngModel={item.mcqquestionid}
                                // name="selectedoption"
                                id={itemname.id}
                                //checked={item.mcqquestionid}
                                //  defaultChecked={itemname.id}
                                value={itemname.id}
                                onChange={(e) =>
                                  this.setState({
                                    selectedoption: e.target.value,
                                    filepath: itemname?.mcqfilr,
                                    filename: itemname?.mcqfilr?.split(".").pop(),
                                  })
                                }
                                className="adjust-widh"
                              />
                            </div>
                            </div>
                            <div className="col-10 col-md-10 col-lg-10 radio-adj1 text-left">
                              <label for={itemname.id}>
                                <Latex>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: itemname.option_value,
                                    }}
                                  />
                                </Latex>
                              </label>
                              {itemname.mcqfilr !== null &&
                              itemname.option_value !== null ? (
                                <>
                                  <Link
                                    onClick={(e) =>
                                      this.setState({
                                        secondModalIsOpen: true,
                                        filepath: itemname?.mcqfilr,
                                        filename: itemname?.mcqfilr?.split(".").pop(),
                                      })
                                    }
                                  >
                                    {"  "}Click here to Open Option  File{"  "}
                                    <FontAwesomeIcon icon={faFileAlt} />{" "}
                                  </Link>
                                  {/* <Modal
                              isOpen={this.state.secondModalIsOpen}
                              onRequestClose={this.closeSecondModal}
                            >
                              <ModalHeader
                                toggle={this.closeSecondModal}
                              ></ModalHeader>
                              <ModalBody >
                                <div>
                                  <MaterialComponent
                                    contentType="contenttype"
                                    contentId="contentid"
                                    materialid="materialid"
                                    materialtype={itemname.mcqfilr
                                      .split(".")
                                      .pop()}
                                    materialpath={itemname.mcqfilr}
                                  />
                                </div>
                              </ModalBody>
                            </Modal> */}
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </Row>
                          <div></div>
                        </li>
                      </ul>
                    </div>
                  ))}
                </>
              )}

              <Modal
                isOpen={this.state.secondModalIsOpen}
                onRequestClose={this.closeSecondModal}
              >
                <ModalHeader toggle={this.closeSecondModal}></ModalHeader>
                <ModalBody>
                  <div>
                    <MaterialComponent
                      contentType="contenttype"
                      contentId="contentid"
                      materialid="materialid"
                      materialtype={this.state.filename}
                      materialpath={this.state.filepath}
                    />
                  </div>
                </ModalBody>
                <ModalFooter></ModalFooter>
              </Modal>
              <div className="row ">
                <div className="col-lg-12 text-center">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={this.state.loading}
                    onClick={(e) =>
                      this.handleSubmit(
                        e,
                        item.mcqquestionid,
                        item.assignmentOfferingid
                      )
                    }
                  >
                    Submit
                  </Button>

                  {this.state.loading === true ? (
                    <CircularProgress
                      size={24}
                      color="green"
                      className="buttonProgress1"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <br />
            </div>
          </>
        ))}
        </div>
        <br />
      </div>
    );
  }
}

export default McqAssesment;
